/* SCC "Beat the Dealer" on every product page: Higher or Lower.
   It deals the deck on the page first, and players can switch to any other deck (window.SCCDecks, scc-decks.js).
   A deck with print files (Pastel) plays with them; any other deck gets cards built from its photo, and the table takes
   that deck's colour. Five right in a row beats the dealer and shows the reward from the section settings. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var RANK = ['2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K', 'A'];
  var SUIT = ['♠', '♥', '♦', '♣'];
  var SKEY = ['s', 'h', 'd', 'c'];
  var NAME = { J: 'Jack', Q: 'Queen', K: 'King', A: 'Ace' };
  var SNAME = ['spades', 'hearts', 'diamonds', 'clubs'];

  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function shuffle(a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  function vibrate(p) { try { if (navigator.vibrate) navigator.vibrate(p); } catch (e) {} }
  function label(c) { var r = RANK[c.r]; return (NAME[r] || r) + ' of ' + SNAME[c.s]; }

  /* fallback cards if scc-decks.js is missing */
  function plainFace(c, photo) {
    var r = RANK[c.r], s = SUIT[c.s], court = c.r >= 9 && c.r <= 11;
    return '<span class="sccd-face' + (c.s === 1 || c.s === 2 ? ' is-red' : '') + '"><span class="sccd-face__idx"><b>' + r + '</b><i>' + s + '</i></span>' +
      (court ? '<span class="sccd-face__court"><img src="' + esc(photo) + '" alt=""><b>' + r + '</b></span>' : '<span class="sccd-face__pip">' + s + '</span>') +
      '<span class="sccd-face__idx sccd-face__idx--b"><b>' + r + '</b><i>' + s + '</i></span></span>';
  }
  function plainBack(photo) { return '<span class="sccd-back"><span class="sccd-back__medal"><img src="' + esc(photo) + '" alt=""></span></span>'; }

  function Arcade(root) {
    var self = this;
    this.root = root;
    this.D = window.SCCDecks || null;
    this.pageH = root.getAttribute('data-handle') || 'deck';
    var own = { h: this.pageH, n: root.getAttribute('data-deck') || 'this deck', i: root.getAttribute('data-photo') || '', s: root.getAttribute('data-sample') || '' };
    this.d = (this.D && this.D.get(this.pageH)) || own;
    this.goal = parseInt(root.getAttribute('data-goal'), 10) || 5;
    this.key = 'scc-hl-' + this.pageH;
    this.best = parseInt(store(this.key) || '0', 10) || 0;
    this.streak = 0; this.busy = false; this.beat = false;
    this.el = {
      cur: root.querySelector('[data-cur]'), next: root.querySelector('[data-next]'),
      hi: root.querySelector('[data-hi]'), lo: root.querySelector('[data-lo]'),
      msg: root.querySelector('[data-msg]'), streak: root.querySelector('[data-streak]'), best: root.querySelector('[data-best]'),
      left: root.querySelector('[data-left]'), pips: root.querySelector('[data-pips]'), win: root.querySelector('[data-win]'),
      copy: root.querySelector('[data-copy]'), share: root.querySelector('[data-share]'), again: root.querySelector('[data-again]'),
      eyebrow: root.querySelector('[data-eyebrow]'), add: root.querySelector('[data-add]'), addId: root.querySelector('[data-add-id]')
    };
    /* what the page rendered, to restore when the player switches back to this page's deck */
    this.pageAdd = this.el.add ? { html: this.el.add.innerHTML, dis: this.el.add.disabled, id: this.el.addId && this.el.addId.value } : null;
    var pips = ''; for (var i = 0; i < this.goal; i++) pips += '<i></i>'; this.el.pips.innerHTML = pips;
    this.el.hi.addEventListener('click', function () { self.guess(1); });
    this.el.lo.addEventListener('click', function () { self.guess(-1); });
    root.addEventListener('keydown', function (e) {
      if (e.target.closest && e.target.closest('.sccd-pick')) return;
      if (e.key === 'ArrowUp') { e.preventDefault(); self.guess(1); }
      if (e.key === 'ArrowDown') { e.preventDefault(); self.guess(-1); }
    });
    if (this.el.copy) this.el.copy.addEventListener('click', function () { self.copy(); });
    if (this.el.share) this.el.share.addEventListener('click', function () { self.share(); });
    if (this.el.again) this.el.again.addEventListener('click', function () { self.el.win.hidden = true; self.root.classList.remove('is-won'); });
    var ph = root.querySelector('[data-deck-picker]');
    if (this.D && ph) this.D.picker(ph, { selected: this.d.h, first: this.pageH, label: ph.getAttribute('data-label') || 'Play with', onPick: function (d) { self.useDeck(d); } });
    /* the real box opens and the deck slides out (decks with box art) */
    var score = root.querySelector('.sca__score');
    if (this.D && this.D.unbox && score) { this.stage = document.createElement('div'); this.stage.className = 'sca__unbox'; score.parentNode.insertBefore(this.stage, score); this.D.unbox(this.stage, this.d); }
    this.newShoe(true);
    this.paint();
    this.tint(true);
  }
  Arcade.prototype.face = function (c) { return this.D ? this.D.face(this.d, RANK[c.r].toLowerCase(), SKEY[c.s]) : plainFace(c, this.d.i); };
  Arcade.prototype.back = function () { return this.D ? this.D.back(this.d) : plainBack(this.d.i); };
  Arcade.prototype.useDeck = function (d) {
    if (!d) return;
    this.d = d;
    var mine = d.h === this.pageH;
    if (this.el.eyebrow) this.el.eyebrow.textContent = String(this.el.eyebrow.getAttribute('data-tpl') || '').split('[deck]').join(d.n);
    if (this.el.add) {
      if (mine && this.pageAdd) { this.el.add.innerHTML = this.pageAdd.html; this.el.add.disabled = this.pageAdd.dis; if (this.el.addId) this.el.addId.value = this.pageAdd.id; }
      else if (d.v) { this.el.add.textContent = d.a ? 'Add the ' + d.n + ' deck · ' + d.p : d.n + ' is sold out'; this.el.add.disabled = !d.a; if (this.el.addId) this.el.addId.value = d.v; }
    }
    /* re-dress the cards on the table without breaking the streak */
    this.setCard(this.el.cur, this.cur, true);
    this.setBack(this.el.next);
    this.tint(mine);
    if (this.stage) this.D.unbox(this.stage, d, { now: true });
    this.say('Now dealing the ' + d.n + ' deck. Your streak carries over.');
  };
  Arcade.prototype.tint = function (page) {
    var root = this.root, d = this.d;
    if (!this.D) return;
    this.D.tint(d).then(function (t) {
      if (!t || this.d !== d) return;
      root.style.setProperty('--sca-accent', t.accent);
      root.style.setProperty('--sca-felt', t.felt);
      root.style.setProperty('--sccd-accent', t.accent);
      if (page) { document.documentElement.style.setProperty('--scc-deck-soft', t.soft); document.documentElement.classList.add('scc-deck-tinted'); }
    }.bind(this));
  };
  Arcade.prototype.newShoe = function (first) {
    var d = []; for (var s = 0; s < 4; s++) for (var r = 0; r < 13; r++) d.push({ r: r, s: s });
    this.shoe = shuffle(d);
    this.cur = this.shoe.pop();
    this.setCard(this.el.cur, this.cur, true);
    this.setBack(this.el.next);
    this.say(first ? 'Is the next card higher or lower? Aces are high.' : 'Fresh deck. Keep the streak going.');
  };
  Arcade.prototype.setCard = function (host, c, up) {
    host.innerHTML = '<div class="sca-card' + (up ? ' is-up' : '') + '"><div class="sca-card__in"><div class="sca-face">' + this.face(c) + '</div><div class="sca-back">' + this.back() + '</div></div></div>';
    host.setAttribute('aria-label', label(c));
  };
  Arcade.prototype.setBack = function (host) {
    host.innerHTML = '<div class="sca-card"><div class="sca-card__in"><div class="sca-face">' + this.back() + '</div><div class="sca-back">' + this.back() + '</div></div></div>';
    host.setAttribute('aria-label', 'Next card, face down');
  };
  Arcade.prototype.odds = function () {
    var hi = 0, lo = 0, r = this.cur.r;
    this.shoe.forEach(function (c) { if (c.r > r) hi++; else if (c.r < r) lo++; });
    var n = this.shoe.length || 1;
    return { hi: Math.round(hi / n * 100), lo: Math.round(lo / n * 100) };
  };
  Arcade.prototype.paint = function () {
    var o = this.odds();
    this.el.hi.querySelector('small').textContent = o.hi + '%';
    this.el.lo.querySelector('small').textContent = o.lo + '%';
    this.el.streak.textContent = this.streak;
    this.el.best.textContent = this.best;
    this.el.left.textContent = this.shoe.length;
    [].forEach.call(this.el.pips.children, function (p, i) { p.classList.toggle('is-on', i < this.streak); }, this);
  };
  Arcade.prototype.say = function (t, cls) {
    this.el.msg.textContent = t;
    this.el.msg.className = 'sca__msg' + (cls ? ' is-' + cls : '');
  };
  Arcade.prototype.guess = function (dir) {
    if (this.busy) return;
    if (!this.shoe.length) { this.newShoe(); this.paint(); return; }
    var self = this; this.busy = true;
    var nxt = this.shoe.pop();
    this.setCard(this.el.next, nxt, false);
    var card = this.el.next.firstElementChild;
    void card.offsetWidth;
    card.classList.add('is-up');
    var res = nxt.r === this.cur.r ? 0 : ((nxt.r > this.cur.r) === (dir > 0) ? 1 : -1);
    setTimeout(function () {
      if (res > 0) {
        self.streak++;
        if (self.streak > self.best) { self.best = self.streak; store(self.key, String(self.best)); }
        self.say(['Right!', 'Nice read.', 'On a roll.', 'The dealer is sweating.', 'Card shark.'][Math.min(self.streak - 1, 4)] + ' ' + label(nxt) + '.', 'win');
        self.root.classList.remove('is-hit'); void self.root.offsetWidth; self.root.classList.add('is-hit');
        vibrate(12);
      } else if (res < 0) {
        self.say('The dealer wins this one: ' + label(nxt) + '. Streak reset.', 'lose');
        self.streak = 0;
        self.root.classList.remove('is-miss'); void self.root.offsetWidth; self.root.classList.add('is-miss');
        vibrate([30, 40, 30]);
      } else {
        self.say('A tie: ' + label(nxt) + '. Push, your streak stands.');
      }
      self.paint();
      if (res > 0 && self.streak === self.goal && !self.beat) self.won();
      setTimeout(function () {
        self.cur = nxt;
        self.setCard(self.el.cur, nxt, true);
        self.el.cur.firstElementChild.classList.add('is-slide');
        self.setBack(self.el.next);
        self.busy = false;
        if (!self.shoe.length) self.newShoe();
        self.paint();
      }, reduce ? 200 : 900);
    }, reduce ? 50 : 520);
  };
  Arcade.prototype.won = function () {
    this.beat = true;
    this.root.classList.add('is-won');
    if (this.el.win) this.el.win.hidden = false;
    vibrate([20, 40, 20, 40, 60]);
    if (window.SCC && window.SCC.markSeen) window.SCC.markSeen(this.d.h);
    /* the reward applies itself at checkout (unless a friend's Deal Me In code is already saved) */
    var code = this.el.copy && this.el.copy.getAttribute('data-code');
    var saved = null; try { saved = localStorage.getItem('scc-dealt'); } catch (e) {}
    if (code && !saved) {
      fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
      var t = this.root.querySelector('.sca__win-text'); if (t) t.textContent = '10% off your first order is applied at checkout. Code ' + code + ' if you need it.';
    }
    if (reduce) return;
    var box = document.createElement('div'); box.className = 'sca-burst'; box.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < 30; i++) {
      var s = document.createElement('i'); s.textContent = SUIT[i % 4];
      if (i % 4 === 1 || i % 4 === 2) s.className = 'is-red';
      s.style.setProperty('--dx', (Math.random() * 2 - 1).toFixed(2)); s.style.setProperty('--dy', (-(0.4 + Math.random())).toFixed(2));
      s.style.setProperty('--rot', ((Math.random() * 2 - 1) * 540 | 0) + 'deg'); s.style.setProperty('--d', (Math.random() * 250 | 0) + 'ms');
      box.appendChild(s);
    }
    this.root.appendChild(box); setTimeout(function () { box.remove(); }, 2200);
  };
  Arcade.prototype.copy = function () {
    var b = this.el.copy, code = b.getAttribute('data-code'), lbl = b.textContent;
    function ok() { b.textContent = 'Copied'; setTimeout(function () { b.textContent = lbl; }, 2000); }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(ok, function () { window.prompt('', code); });
    else window.prompt('', code);
  };
  Arcade.prototype.share = function () {
    var b = this.el.share, url = location.origin + location.pathname;
    var text = 'I called ' + this.best + ' in a row against the dealer with the Shuffle Club ' + this.d.n + ' deck. Your turn:';
    if (window.SCC && window.SCC.winCard) { window.SCC.winCard({ kicker: 'Beat the Dealer', title: this.best + ' in a row. House beaten.', sub: 'Higher or lower with the ' + this.d.n + ' deck', deck: this.d, card: [RANK[this.cur.r].toLowerCase(), SKEY[this.cur.s]], url: location.pathname, text: text }); return; }
    if (navigator.share && window.matchMedia('(pointer: coarse)').matches) { navigator.share({ text: text, url: url }).catch(function () {}); return; }
    var lbl = b.textContent;
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text + ' ' + url).then(function () { b.textContent = 'Link copied'; setTimeout(function () { b.textContent = lbl; }, 2000); });
  };

  function boot() { [].forEach.call(document.querySelectorAll('[data-scc-arcade]:not([data-ready])'), function (r) { r.setAttribute('data-ready', ''); new Arcade(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
